import { request } from '../request'
import { useEnvApi } from '../../composables/useEnvApi'
import { useServerFetch } from '../../composables/useServerFetch'

const RELATED_EMPLOYEES_API_PATH = '/api/v4/bit/web/trader/detail/related-officers'

export type RelatedEmployeeTag = {
  fontColor?: string
  labelType?: number
  tagName?: string
}

export type RelatedEmployeeCompanyFilterOption = {
  companyIco?: string
  /** 公司筛选标识，切换该公司 Tab 时原样传回接口。 */
  companyId?: string
  companyName?: string
  establishedAt?: string
}

export type RelatedEmployee = {
  companyIco?: string
  companyId?: string
  companyLogo?: string
  companyName?: string
  countryCircleFlag?: string
  countryFlag?: string
  countryName?: string
  endDate?: string
  logo?: string
  name?: string
  officerId?: string
  officerStatus?: string
  officerType?: number
  positionNames?: string[] | null
  startDate?: string
  tags?: RelatedEmployeeTag[] | null
  tenure?: string
}

export type GetRelatedEmployeesParams = {
  /** 不传或为空时查询全部公司，指定时由服务端先筛选再分页。 */
  companyId?: string
  traderCode: string
  /** 当前公司筛选下已读取的原始记录数。 */
  offset: number
  pageSize: number
}

export type RelatedEmployeesData = {
  /** 可筛选的公司；至少两家时前端补充“全部” Tab。 */
  companyFilterOptions?: RelatedEmployeeCompanyFilterOption[] | null
  countryFilterOptions?: unknown[] | null
  items?: RelatedEmployee[] | null
  /** 当前 companyId 筛选下的总记录数，不是所有公司的员工总数。 */
  total?: number
}

export type RelatedEmployeesResponse = {
  code?: number
  data?: RelatedEmployeesData | null
  message?: string
  succeed?: boolean
}

/**
 * 获取交易商的关联员工分组列表。
 * @param params 查询参数，包含交易商编码、公司筛选标识、偏移量和每页数量。
 * @returns 关联员工接口原始响应。
 */
export const getRelatedEmployees = async ({
  companyId,
  traderCode,
  offset,
  pageSize,
}: Readonly<GetRelatedEmployeesParams>): Promise<RelatedEmployeesResponse | null> => {
  if (!traderCode) {
    return null
  }

  const api = useEnvApi()
  const params = {
    traderCode,
    offset,
    pageSize,
    ...(companyId ? { companyId } : {}),
  }

  const response = import.meta.server
    ? await useServerFetch<RelatedEmployeesResponse>({
        baseURL: api.wikibitBffGo,
        url: RELATED_EMPLOYEES_API_PATH,
        method: 'GET' as const,
        query: params,
      })
    : await request<unknown, RelatedEmployeesResponse>({
        baseURL: api.v4,
        url: RELATED_EMPLOYEES_API_PATH,
        method: 'GET' as const,
        params,
      })

  return response
}
